import {
	SURVEY_ANSWERED,
	SURVEY_ANSWERS_UPLOADED,
	SURVEY_RESULT_UPLOADED,
	SURVEY_QUESTS_UPLOADED,
	SURVEY_PREPARED,
	SURVEY_START
} from '../actions';
import {
	CheckboxStep,
	GroupStep,
	RadioButtonStep,
	SingleVariantStep,
} from '../model';


const initialState = {
	answers: null,
	result: null,
	questions: null,
	survey: null,
	currentStep: 0,
};

// function createOptions(options) {
// 	return options.map(({ label, value }) => Option(label, value));
// }

// function createAnswer(answers = []) {
// 	return answers.map(
// 		({ title, chain, type, options }) => Answer(title, chain, type, options &&
// 			Object.values(options)));
// }

function createStep({ id, type, title, answers }) {
	switch (type) {
		case 'radio':
			return new RadioButtonStep(id, title, type, answers);
		case 'single':
			return new SingleVariantStep(id, title, type, answers);
		case 'checkbox':
			return new CheckboxStep(id, title, type, answers);
		case 'group':
			return new GroupStep(id, title, type, answers);
		default: break;
	}
}

function distributeGroups(steps) {
	let goups = {};
	return steps.reduce((acc, i) => {
		let ind;
		if (i.group) {
			ind = ((goups[i.group] === undefined) &&
				(goups[i.group] = steps.indexOf(i))) || goups[i.group];
			let groupSteps = (acc[ind] && acc[ind].answers) || [];
			i = { ...i, id: groupSteps.length };
			groupSteps.push(i);
			acc[ind] = {
				id: groupSteps[0].id,
				...acc[ind],
				answers: groupSteps,
				type: 'group'
			};
		} else {
			acc.push(i);
		}
		
		return acc;
	}, []);
}

export default function survey(state = initialState, action) {
	const { type, payload } = action;
	
	switch (type) {
		case SURVEY_START: {
			return { ...state, currentStep: 0 };
		}
		case SURVEY_ANSWERED: {
			const { id, variant: answer } = payload;
			let { survey } = state;
			//let nextStep = questions[id].getChain(variant);
			let nextStep;
			let exteption = survey[id].exception;
			
			if (exteption) {
				if (Array.isArray(answer)) {
					let exceptionStep = exteption[answer.sort()];
					if (exceptionStep) {
						nextStep = exceptionStep;
					} else {
						answer.forEach(ansId => {
							if (exteption[ansId]) {
								nextStep = exteption[ansId];
							}
						});
					}
				} else {
					let exceptionStep = exteption[answer];
					if (exceptionStep) {
						nextStep = exceptionStep;
					}
				}
			}
			
			if (!nextStep) {
				nextStep = survey[id].next;
			}
			
			if (nextStep > 0 && survey[nextStep]) {
				return { ...state, currentStep: nextStep };
			} else {
				return { ...state, currentStep: 0 };
			}
		}
		case SURVEY_RESULT_UPLOADED: {
			return { ...state, result: payload };
		}
		case SURVEY_PREPARED: {
			let { survey, questions, answers } = payload;
			
			answers = answers.reduce((acc, i) => {
				acc[i.id] = i;
				return acc;
			}, {});
	
			questions = questions.reduce((acc, i) => {
				acc[i.id] = createStep(i);
				return acc;
			}, {});
			
			return { ...state, answers, questions, survey: survey[0] };
		}
		case SURVEY_QUESTS_UPLOADED: {
			const steps = distributeGroups(payload).map(s => createStep(s));
			return { ...state, steps };
		}
		case SURVEY_ANSWERS_UPLOADED: {
			const answers = payload.reduce((acc, i) => {
				acc[i.id] = i;
				return acc;
			}, {});
			return { ...state, answers };
		}
		default:
			return state;
	}
}

export const questions = state => state.survey.survey;




// WEBPACK FOOTER //
// ./src/reducers/survey.js